export const primaryIconColor = '#1C1B1F';
export const dangerIconColor = '#C40000';

export const materialIconSpanSx = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
};

export const accordionExpandIconSx = {
  ...materialIconSpanSx,
  color: primaryIconColor,
  fontSize: 20,
};

export const smallCompletedStepIconSx = {
  ...materialIconSpanSx,
  fontSize: 15,
};

export const mediumMaterialIconSx = {
  ...materialIconSpanSx,
  fontSize: 20,
};

export const largeMaterialIconSx = {
  ...materialIconSpanSx,
  fontSize: 22,
};

export const successMaterialIconSx = {
  ...materialIconSpanSx,
  fontSize: 20,
  color: '#4F8506',
  mr: 1.25,
};
